// extracted by mini-css-extract-plugin
module.exports = {"dark":"theme_dark__1bHhe","light":"theme_light__1wn7e"};